import React from 'react';

const AdminContacts: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-max py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Manage Contacts</h1>
        <div className="card p-6">
          <p className="text-gray-600">Contact management interface will be implemented here</p>
        </div>
      </div>
    </div>
  );
};

export default AdminContacts;
